module.exports = __webpack_public_path__ + "static/img/2备份 5.edf0ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/milan/2备份 5.png
// module id = OMbk
// module chunks = 1